<input [name]="groupName" type="checkbox" [id]="groupName" [formControl]="control" />
<label [for]="groupName" class="flex">
  <p>{{ text }}</p>
  @if (isRequired) {
    <p class="text-err">*</p>
  }
</label>
@if (questionText) {
  <app-tooltip [tooltipText]="questionText">
    <i class="fa-solid fa-circle-question text-cb-gold text-20"></i>
  </app-tooltip>
}
@if (control.invalid && control.touched) {
  <p class="input-err">Required field.</p>
}
